import { render, staticRenderFns } from "./MarketingAutomationCreateNameModal.vue?vue&type=template&id=f5c067aa&scoped=true"
import script from "./MarketingAutomationCreateNameModal.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationCreateNameModal.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationCreateNameModal.vue?vue&type=style&index=0&id=f5c067aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c067aa",
  null
  
)

export default component.exports